export default __webpack_public_path__ + "static/media/plus.513bf15c.svg";